<script setup lang="ts">
import { useQueryClient } from "@tanstack/vue-query"
import { useNetwork } from "@vueuse/core"
import { watch } from "vue"
import { useRouter } from "vue-router"
import { Alert, Button, Icon } from "@/components/ui"
import { useTranslation } from "@/composables"
import { useHealthStore } from "@/stores/healthStore"

const router = useRouter()
const queryClient = useQueryClient()
const { t } = useTranslation()
const { isOnline } = useNetwork()

const healthStore = useHealthStore()

watch(
  () => healthStore.isBackendReachable,
  async (isReachable, wasReachable) => {
    if (wasReachable !== isReachable) {
      if (isReachable) {
        if (router.currentRoute.value.name.toLowerCase() === "/callback")
          router.push("/event/dashboard")
        else
          await queryClient.invalidateQueries({ refetchType: "all" })
      }
    }
  },
)
</script>

<template>
  <Alert v-if="!healthStore.isBackendReachable || !isOnline" compact sharp-corners variant="primary-solid" :closable="false">
    <div class="flex items-center justify-between gap-3 md:px-2">
      <div class="flex items-center gap-3">
        <Icon icon="WifiOff" class="shrink-0" />
        <p>{{ t("offline_banner.message") }}</p>
      </div>
      <Button
        variant="tertiary"
        class="border-white text-white hover:bg-white hover:text-primary"
        :disabled="Boolean(healthStore.isCheckingHealth)"
        @click="healthStore.checkHealth"
      >
        <Icon v-if="healthStore.isCheckingHealth" icon="Loading" />
        {{ healthStore.isCheckingHealth ? t("offline_banner.retry_loading") : t("offline_banner.retry_btn") }}
      </Button>
    </div>
  </Alert>
</template>
